// Generated by CoffeeScript 2.7.0
// ==============================================================================
// PROJECTS - KEYWORD
// ==============================================================================
import $ from "jquery";

$(function() {
  if (document.getElementById("keyword") === null) {
    return false;
  }
  return renderMathInElement($('#keyword')[0], {
    delimiters: [
      {
        left: "[[",
        right: "]]",
        display: true
      },
      {
        left: "$$",
        right: "$$",
        display: false
      }
    ]
  });
});
